// extracted by mini-css-extract-plugin
export default {"tooltip":"WC-z","arrow":"XC-z"};